/** localStorage for Q7.5 — what could be improved (single select). */
export const Q7_5_STORAGE_KEY = 'npdsurvey:q7_5';

export const Q7_5_OPTIONS = [
  'Taste/flavour',
  'Overall experience',
  'Strength/intensity',
  'Appearance/pack',
  'Format',
  'Availability',
  'Nothing in particular',
] as const;

export type Q7_5Option = (typeof Q7_5_OPTIONS)[number];

export type Q7_5Answers = {
  selected: Q7_5Option;
};

function isQ7_5Option(v: unknown): v is Q7_5Option {
  return typeof v === 'string' && (Q7_5_OPTIONS as readonly string[]).includes(v);
}

export function readQ7_5Answers(): Q7_5Answers | null {
  try {
    const raw = localStorage.getItem(Q7_5_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const selected = (o as { selected?: unknown }).selected;
    if (isQ7_5Option(selected)) {
      return { selected };
    }
    return null;
  } catch {
    return null;
  }
}

export function writeQ7_5Answers(data: Q7_5Answers): void {
  try {
    localStorage.setItem(Q7_5_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function clearQ7_5Answers(): void {
  try {
    localStorage.removeItem(Q7_5_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isQ7_5Complete(): boolean {
  return readQ7_5Answers() != null;
}
